import React, { useEffect } from 'react';

const SchemaInjector = () => {
  useEffect(() => {
    // FAQ Schema
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is a Gold IRA?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "A Gold IRA is a self-directed Individual Retirement Account that allows investors to hold physical precious metals (gold, silver, platinum, palladium) instead of traditional paper assets like stocks and bonds. It offers the same tax advantages as a standard IRA."
          }
        },
        {
          "@type": "Question",
          "name": "How accurate is the Gold IRA Calculator?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The calculator at SecureGoldInvestments.com provides long-term projections based on historical average returns for both the stock market and physical gold. While it is a highly useful tool for modeling different asset allocation strategies, actual future market performance cannot be guaranteed."
          }
        },
        {
          "@type": "Question",
          "name": "Can I roll over my existing 401(k) into a Gold IRA?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, in most cases. If you have a 401(k) from a previous employer, or if you are over age 59.5, you can typically perform a tax-free, penalty-free rollover into a self-directed precious metals IRA."
          }
        }
      ]
    };

    // WebSite / Organization Schema
    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Secure Gold Investments",
      "url": "https://securegoldinvestments.com",
      "logo": "https://media-manager-c.questera.ai/greta-media/2927c86c700ec49dd101b06d8f665ec936c446223b03db97ee166b3b81a38e088d244e0b8a3abf82b7f680071b9e9e7b/images/aW1hZ2UvcG5n/938af48630f3844187713f8a83e6a456.png",
      "description": "Premium resource for Gold IRA education and interactive retirement planning tools."
    };

    // Software Application Schema for the Calculator
    const softwareSchema = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "Gold IRA Calculator",
      "applicationCategory": "FinanceApplication",
      "operatingSystem": "Web",
      "url": "https://securegoldinvestments.com/#gold-ira-calculator",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD"
      },
      "description": "A free interactive tool to project retirement portfolio growth by comparing a standard paper asset portfolio against a diversified portfolio that includes physical precious metals."
    };

    const injectScript = (schemaObj, id) => {
      let script = document.getElementById(id);
      if (!script) {
        script = document.createElement('script');
        script.id = id;
        script.type = 'application/ld+json';
        document.head.appendChild(script);
      }
      script.innerHTML = JSON.stringify(schemaObj);
    };

    injectScript(faqSchema, 'faq-schema');
    injectScript(organizationSchema, 'org-schema');
    injectScript(softwareSchema, 'software-schema');

    return () => {
      ['faq-schema', 'org-schema', 'software-schema'].forEach(id => {
        const node = document.getElementById(id);
        if (node) document.head.removeChild(node);
      });
    };
  }, []);

  return null;
};

export default SchemaInjector;